import SupplierAPI from 'dashboard/api/suppliers';
import { createStore } from 'dashboard/store/storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import camelcaseKeys from 'camelcase-keys';

export const useSuppliersStore = createStore({
  name: 'suppliers',
  type: 'pinia',
  API: SupplierAPI,
  getters: {
    getSuppliersList: state => {
      return camelcaseKeys(state.records, { deep: true });
    },
    getSupplier: state => id => {
      const supplier = state.records.find(record => record.id === Number(id));
      return supplier ? camelcaseKeys(supplier, { deep: true }) : null;
    },
  },
  actions: () => ({
    async search({ search, page, sort }) {
      this.setUIFlag({ fetchingList: true });
      try {
        const {
          data: { payload, meta },
        } = await SupplierAPI.search(search, page, sort);
        this.records = payload;
        this.setMeta(meta);
      } catch (error) {
        throwErrorMessage(error);
      } finally {
        this.setUIFlag({ fetchingList: false });
      }
    },
  }),
});
